/**
 * 指定したページ設定のvalueを取得する処理
 * @param {String} configName 取得したいページ設定のname
 * @return {String} ページ設定のvalue
 */
export const isPageConfigState = (configName: string): boolean => {
  const targetInput = document.querySelector(`input[name="page-config-${configName}"]`) as HTMLInputElement;
  if (targetInput) {
    return targetInput.value === '0';
  }
  return false;
};

/**
 * 設定パネルの状態を参照して指定した時間を返却する処理
 * @param {Number} time 設定したい時間
 * @return {Number} 設定パネルの状態を参照して指定した時間を返却
 */
export const setTime = (time: number): number => (isPageConfigState('animationDuration') ? 0 : time);

/**
 * 指定された秒数を待機する処理
 * @param {Number} sec 待機したい秒数
 * @return {Function} 待機する処理のPromiseを返却
 */
export const wait = (sec: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, setTime(sec * 1000));
  });
};

/**
 * 連続するイベントを間引くための関数
 * @param {Object} callback イベントの最後に実行したい関数
 */
export const debounce = <T extends (...args: any[]) => void>(
  callback: T,
  delay = 400,
): ((...args: Parameters<T>) => void) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => { callback(...args); }, delay);
  };
};

// ローディングの表示・非表示処理
export const showLoading = () => {
  const loadingView = document.querySelector('.loading-view');
  if (loadingView) {
    loadingView.classList.add('is-show');
  }
};
export const hideLoading = () => {
  const loadingView = document.querySelector('.loading-view');
  if (loadingView) {
    loadingView.classList.remove('is-show');
  }
};

/**
 * ga4のイベントトラッキングの処理
 * @param {String} eventCategory カテゴリ名
 * @param {String} eventName 送信するイベント名
 */
export const sendGa4Event = (eventCategory: string | number, eventName: string | number) => {
  if (window && window?.gtag) {
    window?.gtag('event', 'ga_event_action', {
      'ga_event_category': `${eventCategory}`,
      'ga_event_name': `${eventName}`,
      'send_to': 'G-LW47TGHVE4',
    });
  }
};
